export class Question {
  // private id: string;
  public id: string;
  public name: string;
  public text: string;
  public type: string;

  public minTime: number;
  public maxTime: number;
  public vad: boolean;



  constructor(id: string, title: string, txt: string, questionType: string, minimumTime: number, maximumTime: number, vad: boolean) {
    this.id = id;
    this.name = title;
    this.text = txt;
    this.type = questionType;
    this.minTime = minimumTime;
    this.maxTime = maximumTime;
    this.vad = vad;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/question.model.ts